var api = require("!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/css-loader/dist/cjs.js!./style.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {"attributes":{"id":"@playkit-js/playkit-js-ima"}};

options.insert = function (styleElement) {
    if (window.kalturaGlobalConfig && typeof window.kalturaGlobalConfig.stylesNonce === 'string') {
        styleElement.setAttribute('nonce', window.kalturaGlobalConfig.stylesNonce);
    }
    document.head.appendChild(styleElement);
};
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};